export default __webpack_public_path__ + "static/media/wifi-logo.4c4537e7.png";